// extracted by mini-css-extract-plugin
export default {"wrap":"LoginInput_wrap__6ZJM6","inputBox":"LoginInput_inputBox__C5XW2","label":"LoginInput_label__V7j1H","input":"LoginInput_input__ZeDLo","error":"LoginInput_error__zs61S"};